import { Dispatch } from 'redux'
import { ApplicationState } from '../../../../reducers'
import { markNotificationsAsRead } from '../../../../services/notifications'
import { hideNotificationArea } from './actions'

const hideNotifications = () => (dispatch: Dispatch, getState: () => ApplicationState) => {
    markNotificationsAsRead()
    dispatch(hideNotificationArea())
}

export { hideNotifications }
